<template>
  <project-settings-layout :id="id" :name="name">
    <el-card v-if="!$permissions.canHaveGuests" class="project-settings-assign-people">
      <guest-upgrade-prompt mode="hero" />
    </el-card>
    <el-card v-else class="project-settings-assign-people">
      <template #header>
        <div class="project-settings-assign-people__header">
          <h3>Add/Remove Guests</h3>
          <avatar-gallery
            v-if="!$permissions.isSampleInternalProjectID(id)"
            :people="assignedPeople"
            :max-num-avatars="7"
            stack-tightly
          />
        </div>
      </template>
      <guest-membership-manager
        :entity-type="EEntities.PROJECTS"
        :entity-id="id"
        class="project-settings-assign-people__entity-membership-manager"
        @memberships-updated="(val) => assignedPeople = val"
        @entity-name-fetched="(val) => name = val" />
    </el-card>
  </project-settings-layout>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import ProjectSettingsLayout from '@/layouts/project-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import GuestMembershipManager from './components/guest-membership-manager.vue'
import GuestUpgradePrompt from '@/components/global/guest-upgrade-prompt.vue'

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import { IPersonBase } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'ProjectSettingsAssignGuests',

  components: {
    ProjectSettingsLayout,
    EntitySettingsLoading,
    GuestMembershipManager,
    GuestUpgradePrompt,
  },

  data() {
    return {
      EEntities,
      name: '',
      assignedPeople: [] as IPersonBase[],
    }
  },

  head(): any {
    return {
      title: `Add/Remove Guests - ${this.name}`,
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },
})
</script>

<style lang="scss">
.project-settings-assign-people {
  overflow: visible;
  &__header {
    display: flex;
    justify-content: space-between;
  }
  padding-bottom: 20px;
  &__entity-membership-manager {
    margin-top: -24px;

    .entity-settings-loading {
      padding-top: 20px;
    }
  }
}
</style>
